var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Form } from '@/components/functional/Form/Form';
import { MultiTextField } from '@/components/functional/Form/MultiTextField';
import { SubmitButton } from '@/components/functional/Form/SubmitButton';
import { UserBoxList } from '@/components/modules/List/UserBoxList';
import { ProposalRequestCommentBox } from '@/components/modules/pages/rfp/Surface/ProposalRequestCommentBox';
import { Button } from '@/components/ui/Button/Button';
import { ModalFooterAction } from '@/components/ui/Modal/Modal';
import { ModalWithTitle } from '@/components/ui/Modal/ModalWithTitle';
import { SmallTag } from '@/components/ui/Tag/SmallTag';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { professionalUnitPath } from '@/utils/router/links';
// コメント初期値
const initialValues = {
    comment: '本テーマに関するご実績をお持ちでしたら、ぜひ提案をご検討ください。',
};
// TODO: 処理関連は hook 作って移す
export const ProposalRequestModal = (props) => {
    const { className = '', hideModal: propHideModal, isShow, onClickSubmit: propOnClickSubmit, selectedIds, selectedUsers, } = props;
    const unmountRef = useUnmountRef();
    // UserBoxList表示用に object 変更
    const userBoxListItems = useMemo(() => selectedUsers.map((user) => {
        const { companyName, urlCode } = user, other = __rest(user, ["companyName", "urlCode"]);
        return Object.assign({ extraTexts: companyName
                ? [
                    {
                        link: urlCode ? professionalUnitPath(urlCode) : '',
                        text: companyName,
                    },
                ]
                : [] }, other);
    }), [selectedUsers]);
    // ローディング制御
    const { callbackPromiseEvent, doing: loading } = usePromiseDoingCallback({
        finallyCallbackFunc: propHideModal,
        promiseEvent: propOnClickSubmit,
        unmountRef,
    });
    const onClickSubmit = useCallback((values) => {
        callbackPromiseEvent({
            comment: values === null || values === void 0 ? void 0 : values.comment,
            selectedIds,
        });
    }, [callbackPromiseEvent, selectedIds]);
    // 非同期処理中はモーダル閉じれないよう制御
    const hideModal = useCallback(() => {
        if (!loading) {
            propHideModal();
        }
    }, [loading, propHideModal]);
    return (_jsxs(ModalWithTitle, Object.assign({ className: className, headText: 'コンサルに対して提案希望を伝える', hideModal: hideModal, isShow: isShow }, { children: [_jsxs(Head, Object.assign({ className: 'text-center', size: 'xs' }, { children: ["\u30B3\u30F3\u30B5\u30EB\u306B\u5BFE\u3057\u3066\u63D0\u6848\u3078\u306E\u671F\u5F85\u3092\u4F1D\u3048\u308B\u3053\u3068\u3067", _jsx("br", { className: 'hidden md:inline' }), "\u63D0\u6848\u306E\u53EF\u80FD\u6027\u304C\u9AD8\u307E\u308A\u307E\u3059"] })), _jsx(UserBoxList, { className: 'mt-28', items: userBoxListItems }), _jsx(Form, { initialValues: initialValues, onSubmit: onClickSubmit, render: (renderProps) => (_jsxs("form", Object.assign({ onSubmit: renderProps.handleSubmit }, { children: [_jsxs(ProposalRequestCommentBox, Object.assign({ className: 'mt-28' }, { children: [_jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'sm', tagName: 'span' }, { children: "\u30B3\u30F3\u30B5\u30EB\u30C1\u30FC\u30E0\u3078\u306E\u30B3\u30E1\u30F3\u30C8" })), _jsx(SmallTag, Object.assign({ className: 'ml-8', color: 'inactive' }, { children: "\u4EFB\u610F" })), _jsx("div", Object.assign({ className: 'mt-8' }, { children: _jsx(MultiTextField, { name: 'comment' }) }))] })), _jsxs(ModalFooterAction, Object.assign({ className: 'items-start' }, { children: [_jsx(Button, Object.assign({ color: 'gray', disabled: loading, onClick: hideModal, size: 'md' }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB" })), _jsx(SubmitButton, Object.assign({ color: 'orange', loading: loading, size: 'md' }, { children: "\u9001\u4ED8\u3059\u308B" }))] }))] }))) })] })));
};
